export const ApproveActionMessage = () => {
  return (
    <p className="text-[10px] text-text-500 font-medium">
      The process will be approved and move to next level.
    </p>
  );
};

export const RejectActionMessage = () => {
  return (
    <p className="text-[10px] text-text-500 font-medium">
      The process will be rejected and not move to next level.
    </p>
  );
};

export const HoldActionMessage = () => {
  return (
    <p className="text-[10px] text-text-500 font-medium">
      The process will be put on hold and not move to next level.
    </p>
  );
};

export const InReviewActionMessage = () => {
  return (
    <p className="text-[10px] text-text-500 font-medium">
      The process will be sent for changes to a previous reviewer. It will not
      move to next level.
    </p>
  );
};
